module.exports = __webpack_public_path__ + "index_pc/img/xinli_logo.1ba63fa3.png";